export default __webpack_public_path__ + "static/media/562678.1ac9095b.png";